import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { label: "首頁", to: "/" },
  { label: "關於許文彰", to: "/about" },
  { label: "幸福人才養成系統", to: "/happiness-talent-system" },
  { label: "個人成長", to: "/personal-growth" },
  { label: "企業與團隊培訓", to: "/corporate-training" },
  { label: "課程與活動", to: "/courses" },
  { label: "AI 幸福人才顧問", to: "/ai-coach" },
  { label: "聯絡與合作", to: "/contact" },
];

const COOP_LINKS = [
  { label: "企業培訓", to: "/corporate-training" },
  { label: "講師邀約", to: "/contact" },
  { label: "合作洽談", to: "/contact" },
];

const LEGAL_LINKS = [
  { label: "隱私權政策", to: "/contact" },
  { label: "使用條款", to: "/contact" },
  { label: "AI 使用說明", to: "/ai-coach" },
  { label: "課程／活動相關規範", to: "/courses" },
];

const SOCIALS = [
  { label: "LINE", icon: "ri-line-line" },
  { label: "Email", icon: "ri-mail-line" },
  { label: "Facebook", icon: "ri-facebook-line" },
  { label: "Instagram", icon: "ri-instagram-line" },
  { label: "YouTube", icon: "ri-youtube-line" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-dark text-white">
      <div className="mx-auto max-w-container px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-4">
            <p className="text-lg font-bold">許文彰｜幸福人才總教練</p>
            <p className="mt-4 text-sm leading-[1.9] text-white/70">
              從知道，到做到；
              <br />
              從做到，到持續做到。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-md border border-white/15 text-white/80 cursor-pointer transition-colors duration-200 hover:border-gold hover:text-gold"
                >
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-4">
            <p className="text-sm font-semibold text-gold tracking-wide">快速連結</p>
            <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/75 cursor-pointer transition-colors duration-200 hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Coop + Legal */}
          <div className="lg:col-span-4 grid grid-cols-2 gap-8">
            <div>
              <p className="text-sm font-semibold text-gold tracking-wide">合作</p>
              <ul className="mt-5 flex flex-col gap-3">
                {COOP_LINKS.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/75 cursor-pointer transition-colors duration-200 hover:text-gold"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-sm font-semibold text-gold tracking-wide">法律</p>
              <ul className="mt-5 flex flex-col gap-3">
                {LEGAL_LINKS.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/75 cursor-pointer transition-colors duration-200 hover:text-gold"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10">
          <p className="text-xs text-white/50">
            Copyright © {year} 許文彰／富悅商務發展有限公司. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}